import React, { useEffect, useState } from 'react';
import { useSnapshot } from 'valtio';

import { eventsStore, datasetStore, videoStore, uiStore, appStore, spacecraftStore, previewStore, poiStore, gmapStore, nisarStore, stellarStore, layersStore} from '../managers/globalState';
import globalRefs from '../managers/globalRefs';

import LeftContent from './left-content';
import ar from '../languages/ar';

const DetailPanelLeft = () => {
	const { getManager } = globalRefs;
	const { isDetailPanelOpen, hideExternalLinks: hideExternalLinksFromURL } = useSnapshot(uiStore.state);
	const { isMobile } = useSnapshot(appStore.state);
	const { dem, demModelId } = useSnapshot(layersStore.state);
	const { currentEvent, eventsVisibleOnGlobe } = useSnapshot(eventsStore.state);
	const { currentPoi, showOnGlobePoI } = useSnapshot(poiStore.state);
	const { currentGmap, showOnGlobeGmap } = useSnapshot(gmapStore.state);
	const { currentNisar } = useSnapshot(nisarStore.state);
	const { currentStellar} = useSnapshot(stellarStore.state);
	const { previewEventData } = useSnapshot(previewStore.state);
	const { currentDataset, currentVS, currentIndex } = useSnapshot(datasetStore.state);
	const { currentVideo, isVideoTextureLoaded } = useSnapshot(videoStore.state);
	const { currentSpacecraft, isSatellitesNow } = useSnapshot(spacecraftStore.state);

	const hideExternalLinks = hideExternalLinksFromURL === 'true';
	const [displayData, setDisplayData] = useState(null);

	// useEffect to update the state when the currentDataset changes.
	useEffect(() => {
		const { getManager } = globalRefs;
		const contentManager = getManager('content');
		// console.log("DetailPanelLeft", currentStellar)
		let displayData;
		if (dem) {
			displayData = contentManager.getDemDisplayData();
		} else if (currentPoi){
			displayData = contentManager.getPoiDisplayData()
		} else if (currentNisar) {
			displayData = contentManager.getNisarDisplayData()
		} else if (currentGmap) {
			displayData = contentManager.getGmapDisplayData()
		}  else if (currentStellar) {
			displayData = contentManager.getStellarDisplayData()
		} else if (currentEvent) {
			displayData = contentManager.getEventDisplayData();
		} else if (previewEventData) {
			displayData = contentManager.getEventDisplayData({ preview: true });
		} else if (currentSpacecraft) {
			displayData = contentManager.getSpacecraftDisplayData();
		} else if (currentVideo && isVideoTextureLoaded) {
			displayData = contentManager.getVideoDisplayData();
		} else if (isSatellitesNow) {
			displayData = contentManager.getSatellitesNowDisplayData();
		} else if (currentDataset) {
			displayData = contentManager.getDatasetDisplayData();
		} 

		// set the displayData state.
		displayData && setDisplayData(displayData);
	}, [
		dem,
		demModelId,
		isSatellitesNow,
		currentVS,
		currentDataset,
		currentEvent,
		previewEventData,
		currentSpacecraft,
		currentVideo,
		isVideoTextureLoaded,
		currentIndex,
		currentPoi,
		currentNisar,
		currentGmap,
		currentStellar
	]);

	const { category, title, subtitle, descriptions } = displayData || {};
	const hideDescriptionHeading =
		Boolean(dem || currentGmap || currentPoi || currentEvent || previewEventData)
		|| title?.trim() === ar.Sand_Movement.trim();
	//MERGE ISSUE: New is using eventsVisibleOnGlobe not markersVIsible, showLeftContent is new
  const showLeftContent = displayData && (dem || !eventsVisibleOnGlobe);
	const markersVisible = eventsVisibleOnGlobe || showOnGlobeGmap || showOnGlobePoI
	return (
		<div
			className='left-content'
			style={ markersVisible ? { marginBottom: 10 } : {}}
		>
			<div className={isDetailPanelOpen ? 'ps-0 ps-lg-4' : `${isMobile ? '' : 'ps-3 mb-3'} mb-lg-0 pb-lg-3`}>
				{ showLeftContent && <LeftContent category={category} title={title} subtitle={subtitle} /> }

				<div className='info scrollable'>
					{descriptions?.map((description, index) => (
						<React.Fragment key={index}>
							{!hideDescriptionHeading && (
								<h3 className='section-title pt-lg-3'>
									{description.title}
								</h3>
							)}
							{isVideoTextureLoaded && isMobile && (
								<div className='tab-subtitle'>{description.subtitle}</div>
							)}
							{description.html
								? (
									<div
										className='text pb-1'
										dangerouslySetInnerHTML={{
											__html: hideExternalLinks
												? getManager('content').removeExternalLinks(description.html) :
												description.html
										}}
									/>
								)
								: (
									<div
										className='text pb-1'
										dangerouslySetInnerHTML={{
											__html: hideExternalLinks
												? getManager('content').removeExternalLinks(description.text) :
												description.text
										}}
									/>
								)}
						</React.Fragment>
					))}
				</div>
			</div>
		</div>
	);
};

export default DetailPanelLeft;
